<template>
  <div class="ticket-item" @click="handleClick">
    <!-- 展览集 -->
    <template v-if="data.dataType === 1">
      <div class="pic">
        <a :href="`../share/showSet.html?id=${data.exhibitionGroupCommonBean.id}`" :title="data.exhibitionGroupCommonBean.name" target="_blank"><img :data-src="data.exhibitionGroupCommonBean.imageUrl | imageUrl" :class="data.exhibitionGroupCommonBean.imageUrl | imageClass(data.exhibitionGroupCommonBean.imageWidth, data.exhibitionGroupCommonBean.imageHeight, 0.73)" :src="data.exhibitionGroupCommonBean.imageUrl | imageUrl('?imageView2/1/w/376/h/516')" /></a>
      </div>
      <div class="content">
        <h2 class="title">
          <a :href="`../share/showSet.html?id=${data.exhibitionGroupCommonBean.id}`" :title="data.exhibitionGroupCommonBean.name" target="_blank">{{data.exhibitionGroupCommonBean.name}}</a>
        </h2>
        <p class="name" :title="data.exhibitionGroupCommonBean.pavilion">{{data.exhibitionGroupCommonBean.pavilion}}</p>
        <p class="time">{{data.exhibitionGroupCommonBean.exStartTime | formatDateRange(data.exhibitionGroupCommonBean.exEndTime)}}</p>
        <p class="price">
          <template v-if="data.exhibitionGroupCommonBean.ticketPriceLow === data.exhibitionGroupCommonBean.ticketPriceHigh">{{data.exhibitionGroupCommonBean.ticketPriceLow | price}}</template>
          <template v-else>¥{{data.exhibitionGroupCommonBean.ticketPriceLow}} - {{data.exhibitionGroupCommonBean.ticketPriceHigh}}</template>
        </p>
      </div>
    </template>
    <!-- 展览 -->
    <template v-if="data.dataType === 2">
      <div class="pic">
        <a :href="`../share/show.html?id=${data.exhibitionCommonBean.id}`" :title="data.exhibitionCommonBean.name" target="_blank"><img :data-src="data.exhibitionCommonBean.imageUrl | imageUrl" :class="data.exhibitionCommonBean.imageUrl | imageClass(data.exhibitionCommonBean.imageWidth, data.exhibitionCommonBean.imageHeight, 0.73)" :src="data.exhibitionCommonBean.imageUrl | imageUrl('?imageView2/1/w/376/h/516')" /></a>
      </div>
      <div class="content">
        <h2 class="title">
          <a :href="`../share/show.html?id=${data.exhibitionCommonBean.id}`" :title="data.exhibitionCommonBean.name" target="_blank">{{data.exhibitionCommonBean.name}}</a>
        </h2>
        <p class="name" :title="data.exhibitionCommonBean.pavilion">{{data.exhibitionCommonBean.pavilion}}</p>
        <p class="time">{{data.exhibitionCommonBean.exStartTime | formatDateRange(data.exhibitionCommonBean.exEndTime)}}</p>
        <p class="price">
          <template v-if="data.exhibitionCommonBean.ticketPriceLow === data.exhibitionCommonBean.ticketPriceHigh">{{data.exhibitionCommonBean.ticketPriceLow | price}}</template>
          <template v-else>¥{{data.exhibitionCommonBean.ticketPriceLow}} - {{data.exhibitionCommonBean.ticketPriceHigh}}</template>
        </p>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  name: 'TicketItem',
  props: { data: Object },
  methods: {
    handleClick(event) {
      this.$emit('onClick', event)
    }
  },
  filters: {
    price(value) {
      return value ? `¥${value}` : '免费'
    }
  }
}
</script>
<style scoped>
.ticket-item {
  float: left;
  width: 188px;
  height: 368px;
  margin: 0 21px 30px 0;
}
.ticket-item .pic {
  position: relative;
  width: 100%;
  height: 258px;
  border-radius: 4px;
  overflow: hidden;
  background-color: #e9ebf2;
}

.ticket-item .content {
  margin-top: 10px;
}
.ticket-item .content .title {
  font-size: 16px;
  font-weight: normal;
  line-height: 20px;
  color: #333;
  max-height: 40px;
  overflow: hidden;
}
.ticket-item .content .name {
  margin-top: 10px;
  font-size: 14px;
  line-height: 17px;
  color: #666;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.ticket-item .content .time {
  margin-top: 6px;
  font-size: 12px;
  line-height: 15px;
  color: #666;
}
.ticket-item .content .price {
  margin-top: 6px;
  font-size: 20px;
  line-height: 15px;
  color: #fc4a48;
}
.ticket-item:hover .title {
  color: #1e88f5;
}
</style>
